import {utils_ui} from "../../../applyoo/utils/utils_ui";
import {format} from "date-fns";
import {executeApplyooComponentsFunction} from "../../../applyoo/infrastructure/useApplyooComponent";


// ** Initial State
const initialState = {
    isLoginSucceed: false,
    loginToken: null,
    isReceivedUserInfo: false,
    userDetailsObj: null,
    NumUnconfirmedNotifications: 0,
    NumUnreadChatMessages:0,
    isInSession:false,
    suggestions: [],
    bookmarks: [],
    query: '',
    userObj: null,
    dicCustomUserFlags: {UserDashboardItems: []},
}

export const store_userData = (state = initialState, action) => {
    switch (action.type) {
        case 'FREE_MEMORY':
            return {...state, initialState};

        case 'SET_CUSTOM_USER_FLAG':
            let newState_CustomUserFlag = {...state}
            newState_CustomUserFlag.dicCustomUserFlags[action.customFlagName] = action.customFlagValue

            return newState_CustomUserFlag

        case 'LOGIN_SUCCEED':
            let currDate = format(new Date(),utils_ui.LongDateFormatForSave)
            utils_ui.setLocalStorageItem("LastLoginDT" , currDate ,false)
            //Add local storage key "LastLoginDT", new Date()  - max 5 seconds
            return { ...state, isLoginSucceed: true, isInSession: true }

        case 'SESSION_EXPIRED':
            localStorage.removeItem("AccessToken")
            localStorage.removeItem("RefreshToken")
            localStorage.removeItem("userData")

            const timerId2 = setTimeout(() => {
                executeApplyooComponentsFunction("onLogout", null)
                // sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "navigateToUrl", "urlStr": '/logout'})
                clearTimeout(timerId2)
            }, 10)

            return { ...state, loginToken: null, isInSession: false }

        case 'UPDATE_USER_DATA':
            return { ...state, userObj: action.userObj }

        case 'CHANGE_USER_DETAILS_OBJ':
            return { ...state, userDetailsObj: action.userDetailsObj }

        case 'SET_NUM_UNCONFIRMED_NOTIFICATIONS':
            return { ...state, NumUnconfirmedNotifications: action.numUnconfirmedNotifications }

        case 'SET_NUM_UNREAD_CHAT_MESSAGES':
            return { ...state, NumUnreadChatMessages: action.numUnreadChatMessages }

        case 'UPDATE_BOOKMARKED':
            let objectToUpdate

            // ** find & update object
            state.suggestions.find(item => {
                if (item.id === action.id) {
                    item.isBookmarked = !item.isBookmarked
                    objectToUpdate = item
                }
            })

            // ** Get index to add or remove bookmark from array
            const bookmarkIndex = state.bookmarks.findIndex(x => x.id === action.id)

            if (bookmarkIndex === -1) {
                state.bookmarks.push(objectToUpdate)
            } else {
                state.bookmarks.splice(bookmarkIndex, 1)
            }

            return { ...state }
        default:
            return state
    }
}

// export default store_userData
